import React from "react";
import NewInstallationDetails from './NewInstallationDetails';
import Contact from "../../common/Contact/Contact";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import NewInstallationBanner from "./NewInstallationBanner";

const NewInstallation = () => {
    return (
        <>
      <Menu header_style_2={true} />
      <NewInstallationBanner />
      <NewInstallationDetails />
      <Contact />
      <FooterThree />
    </>
    )
}
export default NewInstallation;